(function() {
  'use strict';
  
  // Feature Columns Slider - 所有设备都支持滑动
  
  // 已初始化的 slider 集合，防止重复初始化
  var initializedSliders = new WeakSet();
  
  // 初始化单个 slider（保留初始化结构，但不修改 draggable 设置）
  function initFeatureColumnsSlider(slider) {
    if (!slider || initializedSliders.has(slider)) {
      return;
    }
    
    // 标记为已初始化
    initializedSliders.add(slider);
  }
  
  // 初始化所有 feature columns sliders
  function initAllFeatureColumnsSliders() {
    try {
      var sliders = document.querySelectorAll('.t4s-feature-columns-slider[data-slider-id]');
      sliders.forEach(function(slider) {
        initFeatureColumnsSlider(slider);
      });
    } catch (e) {
      // 静默处理错误
    }
  }
  
  // 页面加载完成后执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initAllFeatureColumnsSliders, 200);
    });
  } else {
    // 延迟执行，确保其他脚本已加载
    setTimeout(initAllFeatureColumnsSliders, 200);
  }
})();
